const headers = new Headers();
headers.append("Content-Type", "application/json;charset=UTF-8");

import api_data from './key';

const url = IMPEX_AUTH_URI;

const requestOptions = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(api_data),
    redirect: 'follow'
};
  
const api = {
    is_valid: false,
    access: null,
    auth_uri: '',
    auth_tok: '',
    async init() {
        this.access = await fetch(url, requestOptions)
            .then(response => response.text())
            .catch(error => console.log('error', error));

        this.access = JSON.parse(this.access);

        this.auth_tok = this.access.accessToken;
        this.auth_uri = this.access.uri;

        // console.log(this.access)
    }
}

export default api;